<style>
.v-input__icon--clear{
    button{
        margin-right: 30px;
        background-color: #eee;
        border-radius: 3px;
        &:hover{
            background-color: #ccc;
        }
    }
}
</style>
<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <page-title
                        :title="' Carrinhos B2B'"
                        :subtitle="carts.length + ' carrinhos ativos'"
                ></page-title>
            </v-col>
        </v-row>

        <!-- TABELA DE CARRINHOS  -->
        <v-row>
            <v-container fluid>
                <v-card>
                    <v-card-title>
                        Carrinhos
                        <v-spacer></v-spacer>

                        <v-select
                                v-model="filters.brand"
                                label="Marca"
                                :items="brandsList"
                                item-value="VALUE"
                                item-text="TEXT"
                                @change="changeSeller"
                                hide-details
                                clearable
                                class="staff_select"
                        ></v-select>

                        <v-spacer></v-spacer>

                        <v-select
                                v-model="filters.salesman"
                                label="Vendedor"
                                :items="salesmanList"
                                item-value="Vendedor"
                                item-text="Nome"
                                @change="changeSeller"
                                hide-details
                                clearable
                                class="staff_select"
                                v-if="writePermission('b2b/carts')"
                        ></v-select>

                        <v-spacer></v-spacer>

                        <v-text-field
                                v-model="searchCart"
                                append-icon="mdi-magnify"
                                label="Procurar"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>

                    <v-card-text>
                        <v-data-table
                                dense
                                :headers="headersCarts"
                                :items="carts"
                                :items-per-page="25"
                                :footer-props="{
                                    'items-per-page-options': [25,50,100,-1]
                                }"
                                :search="searchCart"
                                :loading="loading"
                                loading-text="Carregando... Por favor aguarde"
                        >
                            <!-- Cliente SLOT -->
                            <template v-slot:item.Cliente="{item}">
                                <p class="mb-0" style="min-width: 450px;max-width: 450px;">
                                    <strong>{{item.Cliente}}</strong> - {{item.Nome}}
                                </p>
                            </template>
                            <!-- Total Artigos SLOT -->
                            <template v-slot:item.totalCart="{item}">
                                <strong class="text-right">{{$money(item.totalCart)}}</strong>
                            </template>
                            <!-- TipoCarrinho SLOT -->
                            <template v-slot:item.cartType="{ item }">
                                <v-chip
                                        color="info"
                                        small
                                        label
                                        dark
                                        v-if="item.cartType === 'Bike'"
                                        style="margin: 4px 2px"
                                >
                                    {{ item.cartType }}
                                </v-chip>
                                <v-chip
                                        color="success"
                                        small
                                        label
                                        dark
                                        v-else
                                        style="margin: 4px 2px"
                                >
                                    {{ item.cartType }}
                                </v-chip>
                            </template>
                            <!-- ACTIONS SLOT -->
                            <template v-slot:item.actions="{ item }">
                                <v-btn small outlined color="warning" @click="getCart(item)">
                                    VER ARTIGOS

                                    <v-icon
                                            small
                                            class="ml-1"
                                            @click=""
                                    >
                                        mdi-eye
                                    </v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-container>
        </v-row>


<!--   TABELA PARA ARTIGOS DO CARRINHO   -->
        <v-dialog v-model="cartProductsDialog" max-width="50%" @click:outside="selectedCart = ''">
            <v-card :loading="loadingProducts">
                <template v-slot:progress>
                    <v-progress-circular
                            :active="loadingProducts"
                            color="#F44336"
                            style="margin: 100px 0; width: 100%;height: 80px"
                            indeterminate
                    ></v-progress-circular>
                </template>

                <v-card-title v-if="!loadingProducts" class="text-h6 lighten-2" style="background-color: #F44336">
                </v-card-title>

                <v-card-text v-if="!loadingProducts">
                    <!-- CLIENT INFO -->
                    <v-row>
                        <v-col cols="4">
                            <h3 class="mb-2 mt-2">{{selectedCart.Cliente}} - {{selectedCart.Nome}}</h3>
                            <p class="mb-1">Email: {{selectedCart.email}}</p>
                            <p class="mb-0">
                                Tipo Cliente:
                                <v-chip
                                        color="info"
                                        small
                                        label
                                        dark
                                        v-if="selectedCart.userType === 'entity'"
                                        style="margin: 4px 2px"
                                >
                                    Master
                                    <v-icon class="pl-1 mr-0" color="yellow" size="20">mdi-crown</v-icon>
                                </v-chip>
                                <v-chip
                                        color="info"
                                        small
                                        label
                                        dark
                                        v-else
                                        style="margin: 4px 2px"
                                >
                                    Contact
                                    <v-icon class="pl-1 mr-0" color="black" size="20">mdi-account</v-icon>
                                </v-chip>
                            </p>
                        </v-col>
                        <v-divider vertical style="border-color: #F44336 !important;"></v-divider>
                        <v-col>
                            <p class="mb-1 mt-2">
                                Tipo Carrinho:
                                <v-chip
                                        color="info"
                                        small
                                        label
                                        dark
                                        v-if="selectedCart.cartType === 'Bike'"
                                        style="margin: 4px 2px"
                                >
                                    {{ selectedCart.cartType }}
                                </v-chip>
                                <v-chip
                                        color="success"
                                        small
                                        label
                                        dark
                                        v-else
                                        style="margin: 4px 2px"
                                >
                                    {{ selectedCart.cartType }}
                                </v-chip>
                            </p>
                            <p class="mb-1">Num. Artigos: {{selectedCart.numArtigos}}</p>
                            <h3 class="mb-0">Total: <strong style="font-size: 20px">{{$money(selectedCart.totalCart)}}</strong></h3>
                        </v-col>
                    </v-row>
                    <!-- PRODUCTS -->
                    <v-row>
                        <v-container fluid>
                            <v-simple-table dense>
                                <thead>
                                <tr>
                                    <th width="20%">Artigo</th>
                                    <th width="40%">Descricao</th>
                                    <th class="text-center">Quantidade</th>
                                    <th class="text-center">Preço Unit.</th>
                                    <th class="text-center">Desconto</th>
                                    <th class="text-right">Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="product in cartProducts">
                                    <td><strong>{{product.productId}}</strong></td>
                                    <td>{{product.descricao}}</td>
                                    <td class="text-center">{{product.quantity}}</td>
                                    <td class="text-center">
                                        {{$money(product.unityPrice)}}
                                    </td>
                                    <td class="text-center">
                                        {{product.discount1}}% {{product.discount2 > 0 ? ' + '+product.discount2 + '%' : ''}} {{product.discount3 > 0 ? ' + '+product.discount3 + '%' : ''}}
                                    </td>
                                    <td class="text-right" style="color: black; font-weight: bold">
                                        {{$money(product.finalPrice)}}
                                    </td>
                                </tr>
                                <!-- TOTAL ROW -->
                                <tr style="background-color: #e0e0e0">
                                    <td></td>
                                    <td class="text-right" style="font-weight: bold; font-size: 14px">TOTAL:</td>
                                    <td class="text-center" style="font-weight: bold;font-size: 14px">{{totalCartProductsQuantity}}</td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right" style="font-weight: bold; font-size: 16px">{{$money(selectedCart.totalCart)}}</td>
                                </tr>
                                </tbody>
                            </v-simple-table>
                        </v-container>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="error"
                            text
                            @click="cartProductsDialog = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>

    </v-container>
</template>
<script>
import i18n from '../../plugins/i18n'
export default {
    data: () => ({
        loading: false,
        loadingProducts: false,
        carts: [],
        salesman: '',
        brand: '',
        filters: {
            salesman: '',
            brand: ''
        },
        headersCarts: [
            {
                text: 'idCart',
                align: 'start',
                filterable: false,
                value: 'idCart',
            },
            { text: 'Cliente', value: 'Cliente' },
            // { text: 'Nome', value: 'Nome' },
            { text: 'Email', value: 'email' },
            { text: 'Tipo Carrinho', value: 'cartType', align: 'center' },
            { text: 'Num.Artigos', value: 'numArtigos', align: 'center' },
            { text: 'Total(€)', value: 'totalCart', align: 'end' },
            { text: 'Ult.Atualização', value: 'lastUpdate', align: 'center' },
            { text: 'Actions', value: 'actions', align: 'center', sortable: false },
        ],
        searchCart: '',
        salesmanList: [],
        brandsList: [],
        cartProductsDialog: false,
        selectedCart: '',
        cartProducts: []
    }),
    mounted() {
        document.title = 'Carrinhos B2B';
        this.initialize()
    },
    computed:{
        totalCartProductsQuantity(){
            if (this.selectedCart != '' && this.cartProducts.length > 0){
                let totalProducts = 0;
                for (const product of this.cartProducts) {
                    totalProducts += (product.quantity * product.economicQuantity)
                }

                return totalProducts;
            }else{
                return 0
            }
        }
    },
    methods: {
        initialize(){
            this.loading = true

            if (!this.writePermission('b2b/carts')) {
                this.filters.salesman = User.getters.getSalesmanId;
            }

            B2B.dispatch('getCarts', this.filters)
                    .then(response => {
                        let responseData = response.data;
                        if (responseData.status === 'OK') {
                            this.carts = responseData.carts;
                            this.salesmanList = responseData.salesman
                            this.brandsList = responseData.brands
                            this.loading = false
                        }
                    })

            if (this.$route.query.client){
                this.searchCart = this.$route.query.client;
                // Criar nova query sem o parâmetro "client" e Atualizar a rota
                const { client, ...rest } = this.$route.query;
                this.$router.replace({ query: rest });
            }
        },
        getCart(cart){
            //Function to get cart details, idea open Modal with this info

            //Select cartId
            this.selectedCart = cart;
            this.loadingProducts = true;

            //Get products inside cart
            B2B.dispatch('getCartProducts', this.selectedCart.idCart)
                    .then(response => {
                        let responseData = response.data;
                        if (responseData.status === 'OK') {
                            this.cartProducts = responseData.cartProducts;
                            this.loadingProducts = false
                        }
                    })

            //Show modal
            this.cartProductsDialog = true;
        },
        writePermission(permission) {
            return User.getters.writePermission(permission)
        },
        changeSeller(){
            this.carts = [];
            this.initialize();
        }
    }
}

</script>